import type { Propriedade } from '../../../@types';
import type { Historico } from '../../../services/historicos';
import { PropriedadeCard, CardTitle } from './propriedade-card';
import CidadeLabel from './cidade-label';

type PropriedadeCardItemProps = {
  propriedade: Propriedade;
  historico: Historico | undefined;
  onNotificacoesClick: (target: HTMLElement) => void;
  onMapaClick: () => void;
};

const PropriedadeCardItem = ({
  propriedade,
  historico,
  onNotificacoesClick,
  onMapaClick,
}: PropriedadeCardItemProps) => (
  <PropriedadeCard
    key={propriedade.uuid}
    title={
      <CardTitle
        propriedade={propriedade}
        naoLidas={historico?.naoLidas}
        onNotificacoesClick={onNotificacoesClick}
      />
    }
    footer={
      propriedade.cidade ? (
        <CidadeLabel
          cidade={propriedade.cidade}
          atualizado={historico?.atualizado}
        />
      ) : null
    }
  >
    <div onClick={onMapaClick} role="button" tabIndex={0}>
      <img src={propriedade.mapaUrl} alt="Mapa" width="100%" />
    </div>
  </PropriedadeCard>
);

export default PropriedadeCardItem;
